export default "__VITE_ASSET__C58O_gYO__"